module.exports = __webpack_public_path__ + "img/team3.d912635c.png";